import { useLanguage } from "../context/LanguageContext";

/**
 * Language switcher (EN ↔ AR). Use with `fixed` for a global corner button, or inline in a nav row.
 * @param {{ fixed?: boolean; style?: import("react").CSSProperties }} [props]
 */
export default function LanguageToggle({ fixed = false, style: outerStyle }) {
  const { lang, toggleLang } = useLanguage();

  const langBtnStyle = {
    background: "rgba(var(--c-on-bg),0.06)",
    border: "1px solid rgba(var(--c-on-bg),0.1)",
    color: "rgba(var(--c-on-bg),0.6)",
    borderRadius: 10,
    padding: "7px 14px",
    fontFamily: lang === "ar" ? "'Tajawal',sans-serif" : "'DM Sans',sans-serif",
    fontSize: 13,
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.18s",
    ...outerStyle,
  };

  /** Top-end corner (hidden on /admin and /dashboard — those layouts render an inline toggle). */
  const wrap =
    fixed === true
      ? {
          position: "fixed",
          top: "calc(20px + env(safe-area-inset-top, 0px))",
          insetInlineEnd: 24,
          zIndex: 150,
        }
      : undefined;

  const btn = (
    <button
      type="button"
      aria-label={lang === "en" ? "العربية" : "English"}
      onClick={() => toggleLang()}
      style={langBtnStyle}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(201,168,76,0.1)";
        e.currentTarget.style.borderColor = "rgba(201,168,76,0.3)";
        e.currentTarget.style.color = "#c9a84c";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(var(--c-on-bg),0.06)";
        e.currentTarget.style.borderColor = "rgba(var(--c-on-bg),0.1)";
        e.currentTarget.style.color = "rgba(var(--c-on-bg),0.6)";
      }}
    >
      {lang === "en" ? "عربي" : "English"}
    </button>
  );

  if (fixed) {
    return <div style={wrap}>{btn}</div>;
  }
  return btn;
}
